// extracted by mini-css-extract-plugin
export default {"pageWrapper":"VisualsMarketing_pageWrapper__r4Ot5","contentWrapper":"VisualsMarketing_contentWrapper__kCztj","icon":"VisualsMarketing_icon__ieftN"};